export const ACTIONS = {
  SET_COMPRA_CLICK_PRODUCT: 'compraClick/SET_COMPRA_CLICK_PRODUCT',
};

export default ACTIONS;
